// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#eu-council-game-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.modal-error {
  display: flex;
  justify-content: center;
  z-index: 20;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #0B375A;
}

.modal-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: transparent;
}
.modal-overlay.blue {
  background-color: var(--color-primary-blue);
}

.background {
  background: url('start-screen-back.41d08f44ece0164f.jpg') no-repeat center center/cover;
  width: 100%;
  height: 100%;
  z-index: 0;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}
.background.visible {
  visibility: visible;
  opacity: 1;
}
.background.splash-screen {
  background: #0B375A;
}
.background.launch-screen {
  background-image: url('start-screen-back.41d08f44ece0164f.jpg');
}
.background.game-choose {
  background-image: url('game-choose-bg.5cf0068ec4afeb4b.jpg');
}
.background.customize-avatar {
  background-image: url('avatar-customize-back2.6fba9e3e8952eca4.jpg');
}
.background.quiz-game {
  background-image: url('quiz-bg.bbe7233eca467f30.jpg');
}
.background.presentation-of-mission {
  background-image: url('pres_mission.40a4c912837f05a8.jpg');
}
.background.presentation-proposal {
  background-image: url('presentationBG.16d7c9130515e3cc.jpg');
}
.background.overview {
  background-image: url('overview-bg.69a65618d9f40365.jpg');
}
.background.select-mode {
  background-image: url('selectModeBack.3a93cf1cb0d9d33a.jpg');
}
.background.negotiation-phase {
  background-image: url('negotiation-bg.675b16c76bcc4901.jpg');
}
.background.game-results {
  background-image: url('game-results-bg.5a5c69afccf1d684.jpg');
}
.background.game-settings {
  background-image: url('settings-bg.c5f3396e55eb1dfc.jpg');
}
.background.bilateral-discussion {
  background-image: url('bilateral-discussion-bg.d509b9bae1fcdb3b.jpg');
}
.background.book {
  background-image: url('book-bg.c880e2e4568355db.jpg');
}
.background.achievements {
  background-image: url('achievements-bg.dbd87804f19cfee2.jpg');
}

.router {
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;AACF;AACE;EACE,2CAAA;AACJ;;AAGA;EACE,uFAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EAGA,yCAAA;AAAF;AAEE;EACE,mBAAA;EACA,UAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,+DAAA;AAFJ;AAKE;EACE,4DAAA;AAHJ;AAME;EACE,oEAAA;AAJJ;AAOE;EACE,qDAAA;AALJ;AAQE;EACE,0DAAA;AANJ;AASE;EACE,4DAAA;AAPJ;AAUE;EACE,yDAAA;AARJ;AAWE;EACE,4DAAA;AATJ;AAYE;EACE,4DAAA;AAVJ;AAaE;EACE,6DAAA;AAXJ;AAcE;EACE,yDAAA;AAZJ;AAeE;EACE,qEAAA;AAbJ;AAgBE;EACE,qDAAA;AAdJ;AAiBE;EACE,6DAAA;AAfJ;;AAmBA;EACE,UAAA;AAhBF","sourcesContent":["#eu-council-game-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.modal-error {\n  display: flex;\n  justify-content: center;\n  z-index: 20;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background-color: #0B375A;\n}\n\n.modal-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: transparent;\n\n  &.blue {\n    background-color: var(--color-primary-blue);\n  }\n}\n\n.background {\n  background: url(../assets/backgrounds/start-screen-back.jpg) no-repeat center center/cover;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  position: absolute;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: opacity 0.3s, visibility 0.3s;\n  -moz-transition: opacity 0.3s, visibility 0.3s;\n  transition: opacity 0.3s, visibility 0.3s;\n\n  &.visible {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  &.splash-screen {\n    background: #0B375A;\n  }\n\n  &.launch-screen {\n    background-image: url(../assets/backgrounds/start-screen-back.jpg);\n  }\n\n  &.game-choose {\n    background-image: url(../assets/backgrounds/game-choose-bg.jpg);\n  }\n\n  &.customize-avatar {\n    background-image: url(../assets/backgrounds/avatar-customize-back2.jpg);\n  }\n\n  &.quiz-game {\n    background-image: url(../assets/backgrounds/quiz-bg.jpg);\n  }\n\n  &.presentation-of-mission {\n    background-image: url(../assets/backgrounds/pres_mission.jpg);\n  }\n\n  &.presentation-proposal {\n    background-image: url(../assets/backgrounds/presentationBG.jpg);\n  }\n\n  &.overview {\n    background-image: url(../assets/backgrounds/overview-bg.jpg);\n  }\n\n  &.select-mode {\n    background-image: url(../assets/backgrounds/selectModeBack.jpg);\n  }\n\n  &.negotiation-phase {\n    background-image: url(../assets/backgrounds/negotiation-bg.jpg);\n  }\n\n  &.game-results {\n    background-image: url(../assets/backgrounds/game-results-bg.jpg);\n  }\n\n  &.game-settings {\n    background-image: url(../assets/backgrounds/settings-bg.jpg);\n  }\n\n  &.bilateral-discussion {\n    background-image: url(../assets/backgrounds/bilateral-discussion-bg.jpg);\n  }\n\n  &.book {\n    background-image: url(../assets/backgrounds/book-bg.jpg);\n  }\n\n  &.achievements {\n    background-image: url(../assets/backgrounds/achievements-bg.jpg)\n  }\n}\n\n.router {\n  z-index: 2;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
